module.exports = __webpack_public_path__ + "media/images/steps_inactive_right_arrow-ab70c9e77c8fa3c72a288d734fefc282.png";